import { createAction, props } from '@ngrx/store';
export const setChartType = createAction('[Scatter Plot] Set Chart Type', props());
